import PropTypes from 'prop-types';
import styles from './styles.module.scss';

export const Spinner = ({ style = {} }) => {
  return <div style={{ ...style }} className={styles.loader} />;
};

Spinner.propTypes = {
  style: PropTypes.object,
};
